import type {ReactElement} from 'react';
import React, {useContext} from 'react';
import {SocialAccountButton} from '@Components/social-media/components/social-account-button';
import {SocialPlatform, SocialUniquePlatforms} from '@Components/social-media/social-media.types';
import {updateAccountTypeToConnect, updateTriggerNext} from '@Components/social-media-wizard/social-media-wizard-reducer';
import {SocialMediaWizardContainerQueriesContext} from '@Components/social-media-wizard/social-media-wizard-container-queries-context';
import {isUserLoggedIn} from '@Libraries/user.library';
import {useIsGoogleBusinessProfileEnabled} from '@Components/social-media-wizard/social-media-wizard.hooks';
import {openAuthenticateModal} from '@Modals/authenticate-modal/authenticate-modal-library';
import styles from './social-account-buttons.module.scss';
import {useAppDispatch} from '@/hooks';

export function SocialAccountButtons(): ReactElement<any> {
  const platformElements: ReactElement<any>[] = [];
  const dispatch = useAppDispatch();
  const {isExtraLargeScreen, isLargeScreen} = useContext(SocialMediaWizardContainerQueriesContext);
  const isGoogleBusinessProfileEnabled = useIsGoogleBusinessProfileEnabled();

  const getAvailableSocialPlatforms = (): SocialPlatform[] => {
    const disabledPlatforms: SocialPlatform[] = [];

    if (!isGoogleBusinessProfileEnabled) {
      disabledPlatforms.push(SocialPlatform.GOOGLE_BUSINESS_PROFILE);
    }

    return SocialUniquePlatforms.filter((platform) => {
      return !disabledPlatforms.includes(platform);
    });
  };

  const onSocialAccountClick = (platform: SocialPlatform): void => {
    if (isUserLoggedIn()) {
      dispatch(updateAccountTypeToConnect(platform));
      dispatch(updateTriggerNext());
    } else {
      openAuthenticationModal(platform);
    }
  };

  const openAuthenticationModal = (platform: SocialPlatform): void => {
    openAuthenticateModal({
      fbPermissions: '',
      signupSource: 'social-media-wizard',
      panelText: window.i18next.t('pmwjs_make_account_to_publish_post'),
      panelSubtext: window.i18next.t('pmwjs_login_publishing_promotion_subtext'),
      onLoginSuccess: async () => {
        onSocialAccountClick(platform);
      },
    });
  };

  getAvailableSocialPlatforms().forEach((platform) => {
    platformElements.push(
      <SocialAccountButton
        key={platform}
        type={platform}
        onClick={(): void => {
          onSocialAccountClick(platform);
        }}
      />
    );
  });

  return (
    <div id="connect-accounts-onboarding-container" className={`${isExtraLargeScreen || isLargeScreen ? styles.platformsGrid : `${styles.mobileGridSpacer} flex-v-row`}`}>
      {platformElements}
    </div>
  );
}
